// Central role-label helper. Display strings come from the DB (/api/role-labels)
// via RoleLabelsContext; these are the offline fallbacks and the key resolver.

export const DEFAULT_LABELS = {
  platform_owner:       'Platform Owner',
  'broker.company':     'Broker Company',
  'broker.admin':       'Broker Admin',
  'broker.manager':     'Broker Manager',
  'broker.adviser':     'Broker Adviser',
  'introducer.company': 'Introducer Company',
  'introducer.manager': 'Introducer Manager',
  'introducer.adviser': 'Introducer Adviser',
};

// Normalise a stored tier value to one of: company | admin | manager | adviser
// ('admin' = full access like an owner, but not a director — see
// ROLES-PERMISSIONS-TIDYUP-SCOPE.md §5. Deliberately its own tier, not
// folded into 'company', so it gets its own distinct label.)
export function normaliseTier(level) {
  if (!level) return null;
  const v = String(level).toLowerCase();
  if (v === 'owner' || v === 'company') return 'company';
  if (v === 'admin') return 'admin';
  if (v === 'manager') return 'manager';
  if (v === 'adviser' || v === 'advisor' || v === 'sales') return 'adviser';
  return null;
}

// Build the label key for a given segment ('broker'|'introducer') + tier value
export function segmentTierKey(segment, tier) {
  const t = normaliseTier(tier) || 'adviser';
  return (segment === 'introducer' ? 'introducer.' : 'broker.') + t;
}

// Resolve the label key from a full user object (role + level fields, any casing)
export function roleLabelKey(user = {}) {
  const role = String(user.role || '').toLowerCase();
  if (role === 'platform_owner') return 'platform_owner';
  if (role === 'introducer') {
    return segmentTierKey('introducer', user.introducer_level ?? user.introducerLevel);
  }
  // brokers: role is always 'broker', broker_level carries the tier
  // (owner/admin/manager/adviser). 'owner' as a role value was retired
  // 20 Aug 2026 — the fallback below is legacy-safe, not load-bearing.
  const tier = user.broker_level ?? user.brokerLevel ?? (role === 'owner' ? 'company' : null);
  return segmentTierKey('broker', tier);
}
